import {currentPage, initNewSection} from '../common/layout';
import initLoadMoreBtn from '../common/load-more-btn';
import { banners, hybridLazyLoad } from '../common/utils/fn';
import { getCBSWidget } from '../common/shop/cbs-widget-loader';

currentPage.pageInit = ($page, pageData, pageId) => {
    let currentEdition = document.querySelector('body').dataset.edtn;
    initLoadMoreBtn();
    // bigImgLazyload();
    if (currentEdition == 'us' || currentEdition == 'ev_us') {
        getCBSWidget().then((api) => {
          api.cbsWidget();
        });
    }
}

currentPage.pageLoadMore = ($html, $btnBox) => {
    $btnBox.replaceWith($html);
    initNewSection($html);
    // bigImgLazyload();
    hybridLazyLoad();
    banners($html);
}